import { module } from 'modujs';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import { ENV } from '../config.js';

Swiper.use([Navigation]);

export default class extends module {
    constructor(m) {
        super(m);
    }   

    init() {
        this.spv = 2;
        switch (this.el.dataset.webinarCarouselStyle) {
            case 'large':
                this.spv = 2;
                break;
            case 'medium':
                this.spv = 3;
                break;
            case 'small':
                this.spv = 4;
                break;
            default:
                this.spv = 2;
        }


        this.swiper = new Swiper(this.el.querySelector('.swiper'), {
            slidesPerView: 1,
            spaceBetween: 10,
            // allowTouchMove: ENV.IS_TOUCH,
            breakpoints: {
                480: {
                    slidesPerView: 2,
                    spaceBetween: 20
                },
                1000: {
                    slidesPerView: this.spv,
                    spaceBetween: 20
                },
            },
            modules: [Navigation],
            navigation: {
                nextEl: this.el.querySelector('.c-webinar-carousel_nav.-next'),
                prevEl: this.el.querySelector('.c-webinar-carousel_nav.-prev'),
            }
        });
    }
}
